import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory, IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { IQueryCommand } from "@features/filter";
import { IPagedData } from "@features/grid";
import { MergePatient } from "../merge-patient";
import { setArrayFieldsLocalTimeZone, setFieldsLocalTimeZone, setPageFieldsLocalTimeZone } from "@mipro/classes/date-utils";

@Injectable({
    providedIn: "root"
})
export class MergePatientsDataService extends BaseDataService {
    readonly url = "api/merge-patients";

    constructor(
        protected http: HttpClient,
        protected handlersFactory: HttpResponsesHandlersFactory
    ) {
        super(http, handlersFactory);
    }

    async getPage(queryCommand: IQueryCommand, responseHandlerSettings?: IHttpResponseHandlerSettings) {
        const page = await this.handleRequest(
            this.http.get<IPagedData<MergePatient>>(`${this.url}/page`, { params: this.constructHttpParams(queryCommand) }),
            this.handlersFactory.getForReadByFilter(responseHandlerSettings)
        );

        setPageFieldsLocalTimeZone(page, "createdDateTime", "dateOfBirth");

        return page;
    }

    async getPatient(patientId: string) {
        const patient = await this.handle(this.http.get<MergePatient>(`${this.url}/${patientId}`));

        if (patient) {
            setFieldsLocalTimeZone(patient, "createdDateTime", "dateOfBirth");
        }

        return patient;
    }

    async getAllPendingMatchingPatientMerges() {
        const items = await this.handleRequest(this.http.get<MergePatient[]>(`${this.url}/pending-merges`));

        setArrayFieldsLocalTimeZone(items, "createdDateTime", "dateOfBirth");

        return items;
    }
}
